<template>
  <!-- FLIGHT DETAILS HEADER -->
  <div class="message is-info is-light mt-2">
    <div v-if="bookTrip.flight" class="message-body has-text-info">
      <b-icon icon="airplane"></b-icon>
      Your flight arrives at {{ flightArrivalLeg.arrivingAirport }} on
      {{ flightArrivalFormatted
      }}<span v-if="flightDepartureLeg">
        and departs {{ flightDepartureLeg.departingAirport }} on
        {{ flightDepartureFormatted }}</span
      >.
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
export default {
  mixins: [bookingMixin],
  props: {},
  data() {
    return {};
  },
  computed: {
    flightDepartureFormatted() {
      return (
        this.flightDepartureMoment?.format("M/D/YYYY") +
        " at " +
        this.flightDepartureMoment?.format("LT")
      );
    },
    flightArrivalFormatted() {
      return (
        this.flightArrivalMoment?.format("M/D/YYYY") +
        " at " +
        this.flightArrivalMoment?.format("LT")
      );
    },
  },
  methods: {},
};
</script>

<style></style>
